/**
 * Get Calendar Entries Grouped Use Case
 */

import { GroupedCalendarEntries } from "../../../../../compliance/domain/entities";
import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class GetCalendarGroupedUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(): Promise<GroupedCalendarEntries> {
    return await this.repository.getCalendarGrouped();
  }
}

